import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('orderSpots', orderSpots);

function orderSpots($translate) {
  return function orderSpotsFilter(orderPackagesRef, enableSuffix) {
    let spotsSum;

    if (orderPackagesRef) {
      spotsSum = orderPackagesRef.reduce((acc, item) => {
        if (item?.requiredSpots) {
          acc += (item.requiredSpots * (item.count || 1));
        }
        return acc;
      }, 0);
    }

    return enableSuffix ? $translate.instant(spotsSum == 1 ? 'X_SPOT' : 'X_SPOTS', {sum: spotsSum}) : spotsSum;
  }
}
